export default __webpack_public_path__ + "static/media/norway-flag.1439df60.png";